import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from 'store/actions/index';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import * as DataUtil from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';

class CustomSearchController extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        }
    }

    startSearch = () => {
        const { customLastSearch } = this.props;
        let searchParams = {};
        if (customLastSearch && customLastSearch.searchType === "fulltext") {
            const { currentSearch } = this.props.flexObjects;
            searchParams = { ...customLastSearch.params, keyword: customLastSearch.keyword, offset: 0, customCurrentSortOption: this.props.customCurrentSortOption };
            if (currentSearch && currentSearch.params && currentSearch.params.fields) searchParams.fields = currentSearch.params.fields;
            if (this.props.flexObjects.startMultiSort) searchParams.startMultiSort = true;
            this.props.history.push({
                pathname: '/search', searchParams: searchParams,
                state: { search: JSON.stringify(searchParams) }
            });

        }

        if (customLastSearch && customLastSearch.searchType === "byfields") {
            searchParams = { ...customLastSearch.params, customCurrentSortOption: this.props.customCurrentSortOption };
            if (this.props.flexObjects.startMultiSort) searchParams.startMultiSort = true;
            this.props.history.push({
                pathname: '/search', searchParams: searchParams,
                state: { search: JSON.stringify(searchParams) }
            });
            this.setState({ isLoaded: true });
        }

        if (this.props.flexObjects.startMultiSort) {
            this.props.updateFlexObjects({ startMultiSort: false, activateMultiSort: false });
        }
    }

    updateSearchData = () => {
        let searchCount = this.props.search.count;
        let obj = this.props.clips;
        let clipsCount = DataUtil.ObjectLength(obj);

        if (searchCount > clipsCount) {
            this.startSearch();
        }
    }

    reloadProjectData = () => {
        if (this.props.customCurrentProject) {
            let type = this.props.customCurrentProject.type;
            let id = this.props.customCurrentProject.clipListId;
            this.props.onLoadClips(type, id);
        }
    }

    componentDidUpdate(prevProps) {
        try {
            if (!DataUtil.isPorscheArchiv() && (this.props.customLoading !== prevProps.customLoading)) {
                this.updateSearchData();
            }

            if (DataUtil.isPorscheArchiv() && !this.props.flexObjects.flexInProject &&
                ((this.props.customCurrentSortOption !== prevProps.customCurrentSortOption)
                    || (this.props.flexObjects.activateMultiSort && !prevProps.flexObjects.activateMultiSort)
                )) {
                this.startSearch();
            }
        } catch (error) {
            console.log("LAMTESTcomponentDidUpdate");
        }
    }

    render() {
        return (<div></div>)
    }
}

const mapStateToProps = (state) => ({
    search: state.search,
    searchCount: state.search.count,
    customLoading: state.search.customLoading,
    customLastSearch: state.customData.customLastSearch,
    clips: state.clipList.clips,
    customCurrentSortOption: state.customData.customCurrentSortOption,
    customProjectReload: state.search.customProjectReload,
    customCurrentProject: state.customData.customCurrentProject,
    flexObjects: state.flex.flexObjects,

});
const mapDispatchToProps = (dispatch) => {
    return {
        setCustomCurrentSortOption: (option) => dispatch(actions.setCustomCurrentSortOption(option)),
        onLoadClips: (clipListType, clipListId) => dispatch(actions.getClipsForClipList(clipListType, clipListId)),
        updateFlexObjects: (obj) => dispatch(actions.updateFlexObjects(obj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomSearchController));


export const updateSearchDataForApps = data => {
    try {
        if (data) {
            const regex = /[/*]/gi;
            return data.replace(regex, "%");
        }
    }
    catch (err) {
        console.log("updateSearchDataForApps");
    }
    return data;
}

export const getApiString = (value) => {
    let tmp1 = /\(/gi;
    value = value.replace(tmp1, '\\(');
    let tmp2 = /\)/gi;
    value = value.replace(tmp2, '\\)');
    value = "(^|;)" + value + "(;|$)";

    return value;
}

export const convertApiString = (data) => {
    let dataArr = data.split(';');
    let searchArr = dataArr.map(value => getApiString(value))

    return searchArr.join("|");
}

export const convertFileTypes = (data) => {
    let filetype;
    switch (data) {
        case 'Video':
            filetype = CustomTypes.CUSTOM_VIDEO_TYPE;
            break;
        case 'Foto':
            filetype = CustomTypes.CUSTOM_IMG_TYPE;
            break;
        case 'Document':
            filetype = CustomTypes.CUSTOM_DOCUMENT_TYPE;
            break;
        case 'Audio':
            filetype = CustomTypes.CUSTOM_AUDIO_TYPE;
            break;
    }
    return convertApiString(filetype);
}


export const isISOString = (date) => {
    const tmp = date;
    if (new Date(tmp) !== "Invalid Date" && !isNaN(new Date(tmp))) {
        if (tmp == new Date(tmp).toISOString()) {
            console.log("Valid date");
            return true;
        } else {
            console.log("Invalid date");
            return false;
        }
    } else {
        console.log("Invalid date");
        return false;
    }
}


export const shouldChangeFilterTypes = (mainData, subData) => {
    let exists = true;
    mainData.map(item => {
        if (subData.indexOf(item) === -1)
            exists = false;
    })

    if (!exists) return true;
    return false;
}

export const updateSearchObjects = (objects, container = null, language) => {
    let lg = DataUtil.getLanguage(language);
    for (let i in objects) {
        if (objects[i] === 'Animation / CGI') objects[i] = 'cgi';
        if ((typeof objects[i] === undefined) || objects[i] === "" || objects[i] === 'no' || objects[i] === null || typeof objects[i] == 'undefined')
            delete objects[i];
        if ((i.endsWith('_ids') && DataUtil.isPMDB() && !i.endsWith('txt10_ids') && !i.endsWith('modelle_ids')
            && !i.endsWith('tags_ids')) || i.endsWith('_tmp') || i.endsWith('Items') || i.endsWith('_checked')
            || (i === 'file') || (i === 'oneClip') || (i === 'selectedObjects')) delete objects[i];

        if (i.endsWith('_ids') && !DataUtil.isPMDB() && !(DataUtil.isPorscheArchiv() && i.startsWith('stock_'))) {
            let changed = i.slice(0, i.length - 4);
            objects[changed] = objects[i];
            delete objects[i];
        }

        if (container && container[`${i}CustomData`] && container[`${i}Items`] && !container[`${i}Items`].length) {
            let existingItem = container[`${i}CustomData`].find(item => item[lg] && objects[i] && item[lg].toLowerCase() === objects[i].toLowerCase());
            let newItems = [];
            if (existingItem && existingItem.ID) {
                objects[i] = existingItem.ID;
                newItems.push(existingItem);
                container[`${i}Items`] = newItems;
            }
        }
        if (container && container[`${i}CustomData`] && container[`${i}Items`] && container[`${i}Items`].length === 1) {
            let found = container[`${i}Items`].find(item => item.ID === objects[i]);
            if (!found && container[`${i}Items`][0].ID) {
                objects[i] = container[`${i}Items`][0].ID;
            }
        }

        if (((i === 'modelle' || i === 'tags') && DataUtil.isPMDB())) delete objects[i];

        if (((i === 'stock') && DataUtil.isPorscheArchiv())) delete objects[i];
    }
    return (objects);
}


export const changeTimeForSearch = (date, option) => {
    try {
        if (date) {
            let newDate = null;
            if (isISOString(date)) newDate = DataUtil.subStringBefore(date, "T");
            else newDate = DataUtil.subStringBefore(date.toISOString(), "T");

            if (newDate) {
                //if (option === "from")
                //newDate = newDate + "T00:00:00.000Z";
                //else if (option === "to")
                if (option === "to")
                    newDate = newDate + "T23:59:59.000Z";

                return newDate;
            }
        }
    } catch (e) {
        console.log("LAMTEST changeTimeForSearch");
    }
    return date;
}

export const changeSearchObjects = (objects, oldkey, newkey, searchTerm) => {
    let newvalue = null;
    for (let i in objects) {
        if (i === oldkey) {
            if (objects[i].toLowerCase().includes(searchTerm)) {
                newvalue = DataUtil.subStringAfter(objects[i].toLowerCase(), searchTerm);
                if (newvalue !== '') {
                    objects[newkey] = newvalue;
                }
                delete objects[oldkey];
            }
        }
        //addTimeToDate
        if (i.includes("_FromDateTime") && DataUtil.addTimeToDate(objects, i, "FromDateTime", "In"))
            objects[i] = DataUtil.addTimeToDate(objects, i, "FromDateTime", "In");
        if (i.includes("_ToDateTime") && DataUtil.addTimeToDate(objects, i, "ToDateTime", "Out"))
            objects[i] = DataUtil.addTimeToDate(objects, i, "ToDateTime", "Out");
    }
    return objects;
}

export const changeDataForFullTextSearch = (data) => {
    let newData = data.trim().split(" ");
    if (newData.length > 1) {
        newData = newData.map(item => {
            if (item.trim().charAt(0) == "+") return item;
            return "+" + item;
        });
        return newData.join("");
    }
    return data;
}

export const getContainerType = (fields) => {
    let found = false;
    fields.filter(item => {
        if (item.field === "containertype") found = item.value;
    })
    return found;
}

